import React from 'react'
import Header from '../Component/header.tsx'
import Footer from '../Component/footer.tsx'
import { Col, Container, Row } from 'react-bootstrap'
import Doctor from '../assets/suresh.jpg'
import 'bootstrap/dist/css/bootstrap.min.css';

const Physician = () => {
    return (
        <>
            <Header />
            <section style={{paddingBottom:"40px"}}>
                <div className='secition-1-bg-about'>
                    <h1 className='section-1-header-about'>Meet Our Physicians</h1>
                </div>
            </section>
            <Container>
                <Row className="align-items-center">
                    <Col md={5} className="text-center mb-4 mb-md-0">
                        <img className='doctor-img-size' src={Doctor} alt="Dr. Suresh K Menon" />
                    </Col>
                    <Col md={7}>
                        <div className='physician-info single-physician-card'>
                            <div className='doctor-title' style={{ marginBottom: "15px" }}>Suresh K Menon, M.D.</div>
                            <p style={{ textAlign: "justify" }}>
                                Dr. Menon was born in Westwood, NJ and moved to the Eastern Panhandle when he was 3. Raised in Charlestown, he attended local schools before graduating from Episcopal High School in Alexandria, Virginia. He received a Bachelor of Sciences in Biology from Georgetown Univer-sity.
                            </p>
                            <p style={{ textAlign: "justify" }}>
                                Dr. Menon earned his Doctor of Medicine from the West Virginia University School of Medicine. He completed an internship at the Washington Hospital Center in DC, followed by residency at the University of Maryland. Dr. Menon is a Diplomate of the American Board of Family Medicine.
                            </p>
                            <p style={{ textAlign: "justify" }}>
                                Dr. Menon received his Dermatology training at Hahn Dermatology and Dermatology Associates and Surgery Center. He completed a Postgraduate Diploma in Practical Dermatology with Dis-tinction from Cardiff University and a Professional Certificate of Dermoscopy from HealthCert. He has served the Martinsburg community for over a decade providing Dermatology care.
                            </p>
                            <p style={{ textAlign: "justify" }}>
                                His special interests include the early detection and treatment of skin cancers and systemic treatments of skin diseases including psoriasis, eczema, acne, hidradenitis suppurativa, and alo-pecia areata.
                            </p>
                            <p style={{ textAlign: "justify" }}>
                                Beyond his medical practice, Dr. Menon cherishes time with his family/friends and enjoys all as-pects of sports.
                            </p>
                        </div>
                    </Col>
                </Row>
            </Container>
            {/* <div className='physician-banner' style={{marginTop:"20px"}}>
                Support Providers
            </div>
            <div className='doctor-title' style={{padding:"0",textAlign:"center",paddingBottom:"30px",color:"#1A2451",fontSize:"50px"}}>Coming Soon...</div> */}
            <Footer />
        </>
    )
}

export default Physician